/* Surroundings slider */
import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);

if (document.querySelector('.surroundings__swiper')) {
  new Swiper('.surroundings__swiper', {
    loop: true,
    speed: 800,
    navigation: {
      prevEl: '.surroundings__prev',
      nextEl: '.surroundings__next',
    },
  });
}

/* Surroundings — parallax + reveal on scroll */
const surroundingBlocks = document.querySelectorAll('.surroundings__block');

if (surroundingBlocks.length) {

  const PARALLAX_SPEED = 0.2;

  const update = () => {
    const vh = window.innerHeight;

    surroundingBlocks.forEach(block => {
      const rect = block.getBoundingClientRect();
      const bg   = block.querySelector('.surroundings__bg');

      // Параллакс
      if (bg && rect.bottom > -vh && rect.top < vh * 2) {
        const offset = (rect.top + rect.height / 2 - vh / 2) * PARALLAX_SPEED;
        bg.style.transform = `translateY(${offset}px)`;
      }

      // Reveal: контент у блока ВНИЗУ (margin-top:auto),
      // поэтому триггерим когда верх блока поднялся выше 25% вьюпорта —
      // в этот момент низ блока уже виден на экране
      if (!block.classList.contains('is-visible') && rect.top < vh * 0.25) {
        block.classList.add('is-visible');
      }
    });
  };

  let rafId = null;
  window.addEventListener('scroll', () => {
    if (rafId) return;
    rafId = requestAnimationFrame(() => { update(); rafId = null; });
  }, { passive: true });

  // Ждём первый paint (двойной rAF) чтобы opacity:0 успел отрисоваться
  requestAnimationFrame(() => requestAnimationFrame(update));
}

/* Burger menu */
const burger = document.querySelector('.header__burger');
const mobileMenu = document.querySelector('#mobileMenu');
const mobileClose = document.querySelector('.mobile-menu__close');

if (burger && mobileMenu) {
  const openMenu = () => {
    burger.classList.add('is-active');
    burger.setAttribute('aria-expanded', 'true');
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };

  const closeMenu = () => {
    burger.classList.remove('is-active');
    burger.setAttribute('aria-expanded', 'false');
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  burger.addEventListener('click', openMenu);

  if (mobileClose) {
    mobileClose.addEventListener('click', closeMenu);
  }

  mobileMenu.querySelectorAll('.mobile-menu__link').forEach(link => {
    link.addEventListener('click', closeMenu);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeMenu();
  });
}
